// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sameTable[data-v-2bfcdc30]{height:105%}[data-v-2bfcdc30] .data-left{text-align:left!important}", ""]);
// Exports
module.exports = exports;
